import React from "react";
export const Impressum = ({ data }) => {
  if (!data) return <div id="impressum">loading...</div>;

  return (

            <div id="impressum-datenschutz" className="py-5">
              <div className="container">
                {/* Impressum */}
                <section id="impressum" className="mb-5 pb-4 border-bottom text-center">
                  <h1 className="h3 mb-4">Impressum</h1>
        
                  <p className="mb-1"><strong>Soroptimist Düsseldorf 2000 e.V.</strong></p>
                  <p className="mb-3">Hetjensstraße 42, 40472 Düsseldorf</p>
        
                  <p className="mb-1"><strong>Vertretungsberechtigt:</strong></p>
                  <p className="mb-3">Dr. Beate Speicher, Dr. Diede Landsberg</p>
                  <p className="mb-3">Registergericht Amtsgericht Düsseldorf VR 7953 eingetragen am 27. April 1995</p>
                  <p className="mb-1"><strong>Kontakt:</strong></p>
                  <p className="mb-3">
                    <a href="mailto:adventskalender@siduesseldorferclubs.de">
                      adventskalender@siduesseldorferclubs.de
                    </a>
                  </p>
        
                  {/*<p className="mb-1"><strong>Registereintrag:</strong></p>
                  <p className="mb-0">
                    Eingetragen im Vereinsregister beim Amtsgericht Düsseldorf<br />
                    Registernummer: {registerNumber}
                  </p>*/}
                </section>
        
                {/* Datenschutzerklärung */}
                <section id="datenschutz" className="text-center">
                  <h2 className="h4 mb-4">Datenschutzerklärung</h2>
        
                  <div className="mx-auto" style={{ maxWidth: 820, textAlign: "left" }}>
                    <h3 className="h6 mt-3">1. Allgemeiner Hinweis</h3>
                    <p>
                      Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Diese Website
                      dient ausschließlich der Bereitstellung von Informationen zu unserem Verein
                      und unseren Aktivitäten.
                    </p>
        
                    <h3 className="h6 mt-3">2. Erhebung und Speicherung personenbezogener Daten</h3>
                    <p className="mb-2">
                      Beim Besuch unserer Website werden durch den Provider automatisch sogenannte
                      Server-Log-Dateien gespeichert. Diese beinhalten z.&nbsp;B.:
                    </p>
                    <ul>
                      <li>Browsertyp und -version</li>
                      <li>Verwendetes Betriebssystem</li>
                      <li>Referrer-URL (zuvor besuchte Seite)</li>
                      <li>Hostname des zugreifenden Rechners</li>
                      <li>Uhrzeit der Serveranfrage</li>
                      <li>IP-Adresse</li>
                    </ul>
                    <p>
                      Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
                      vorgenommen. Die Speicherung dient ausschließlich dem sicheren Betrieb der
                      Website und der Abwehr von Angriffen. Die Daten werden automatisch nach 7 Tagen gelöscht.
                    </p>
                    <p>
                      Darüber hinaus werden keine personenbezogenen Daten erhoben, gespeichert
                      oder verarbeitet.
                    </p>
        
                    <h3 className="h6 mt-3">3. Cookies, Analyse- und Tracking-Tools</h3>
                    <p>
                      Unsere Website verwendet keine Cookies, kein Google Analytics und keine
                      sonstigen Tracking- oder Analysetools.
                    </p>
        
                    <h3 className="h6 mt-3">4. Kontaktaufnahme</h3>
                    <p>
                      Wenn Sie uns per E-Mail kontaktieren, werden die von Ihnen übermittelten
                      Daten (z.&nbsp;B. Name, E-Mail-Adresse, Nachricht) ausschließlich zur
                      Bearbeitung Ihrer Anfrage verwendet. Eine Weitergabe dieser Daten findet
                      nicht statt.
                    </p>
        
                    <h3 className="h6 mt-3">5. Rechte der betroffenen Personen</h3>
                    <p>
                      Sie haben das Recht auf Auskunft über die von uns verarbeiteten
                      personenbezogenen Daten sowie das Recht auf Berichtigung, Löschung,
                      Einschränkung der Verarbeitung und Widerspruch. Darüber hinaus haben Sie
                      das Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde für
                      Datenschutz.
                    </p>
        
                    <h3 className="h6 mt-3">6. Verantwortliche Stelle</h3>
                    <p className="mb-1"><strong>Soroptimist Düsseldorf 2000 e.V.</strong></p>
                    <p className="mb-1">Hetjensstr. 42, 40472 Düsseldorf</p>
                    <p>
                      E-Mail:{" "}
                      <a href="mailto:adventskalender@siduesseldorferclubs.de">
                        adventskalender@siduesseldorferclubs.de
                      </a>
                    </p>
                  </div>
                </section>
              </div>
            </div>
          );
        }
        